<template>
  <div class="Checkbox abc-checkbox">
    <input class="form-check-input" type="checkbox" :id="id" :name="id" :checked="value" @change="onChange" @click="onClick">
    <label class="form-check-label" :for="id"></label>
  </div>
</template>

<script>
export default {
  name: 'Checkbox',
  components: {},
  props: {
    id: [String, Number],
    value: [String, Number, Boolean]
  },
  data: () => ({}),
  methods: {
    onClick (event) {
      this.$emit('selectCheckboxes', event)
    },
    onChange (event) {
      this.$emit('input', event.target.checked)
    }
  }
}
</script>

<style lang="scss">
  .Checkbox {
  }
</style>



// WEBPACK FOOTER //
// src/components/Form/Checkbox/checkbox.vue